import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

export default class CanCoolDrink extends React.Component {
  render() {
    return (
      <Svg width={38} height={37} viewBox="0 0 38 37" fill="none">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.881 8.944h10.434l-4.382 27.875H19.768a7.079 7.079 0 001.218-1.733h2.633v-9.968h-2.79a10.282 10.282 0 00-6.091-5.654l-1.651-10.52H23.5V3.507l1.061-.434L30.675.63 32.246 0l1.257 3.152-1.572.63-5.05 2.01v3.152zM21.084 30.89H0V27.5h2.024a7.826 7.826 0 017.644-6.166h1.749a7.826 7.826 0 017.644 6.166h2.023v3.389zm-19.06 2.54h17.017a4.307 4.307 0 01-4.107 2.995H6.131a4.332 4.332 0 01-4.107-2.994z"
          fill="#003349"
        />
      </Svg>
    );
  }
}
